import { Injectable } from '@angular/core';
import { EbmsVeeyaaConfig } from '../app-config';

/**
 * Service to access application configuration and branding settings
 * Use this service throughout the application to access white-label settings
 */
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  
  constructor() { }
  
  /**
   * Get the complete configuration object
   */
  getConfig(): any {
    return EbmsVeeyaaConfig.config;
  }
  
  /**
   * Get application short name
   */
  getAppName(): string {
    return EbmsVeeyaaConfig.getAppName();
  }
  
  /**
   * Get application full name
   */
  getAppFullName(): string {
    return EbmsVeeyaaConfig.getAppFullName();
  }
  
  /**
   * Get browser title
   */
  getAppTitle(): string {
    return EbmsVeeyaaConfig.getAppTitle();
  }
  
  /**
   * Get company name
   */
  getCompanyName(): string {
    return EbmsVeeyaaConfig.getCompanyName();
  }
  
  /**
   * Get application version
   */
  getAppVersion(): string {
    return EbmsVeeyaaConfig.config.appVersion;
  }
  
  /**
   * Get application description
   */
  getAppDescription(): string {
    return EbmsVeeyaaConfig.config.appDescription;
  }
  
  /**
   * Get copyright text
   */
  getCopyrightText(): string {
    return EbmsVeeyaaConfig.config.copyrightText;
  }
  
  /**
   * Get logo path
   */
  getLogoPath(): string {
    return EbmsVeeyaaConfig.config.logoPath;
  }
  
  /**
   * Get user agent string
   */
  getUserAgent(): string {
    return EbmsVeeyaaConfig.getUserAgent();
  }
  
  /**
   * Get company website
   */
  getCompanyWebsite(): string {
    return EbmsVeeyaaConfig.config.companyWebsite;
  }
  
  /**
   * Get company email
   */
  getCompanyEmail(): string {
    return EbmsVeeyaaConfig.config.companyEmail;
  }
  
  /**
   * Get company phone
   */
  getCompanyPhone(): string {
    return EbmsVeeyaaConfig.config.companyPhone;
  }
}
